module.exports = __webpack_public_path__ + "static/sport/login-2.a0e5a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/form/login-2.png
// module id = z7zQ
// module chunks = 0